@import "./Inputs.scss";

.Input {
  @include transition;
  background: transparent;
  border-color: $input-border-color;
  border-style: $input-border-style;
  border-width: 0;
  color: $input-font-color;
  margin: 0;
  padding: 0;
  width: 100%;

  &::placeholder {
    @include input-placeholder;
  }

  // States

  &.invalid {
    border-color: $input-border-color-invalid;
    color: $input-font-color-invalid;

    &:hover {
      border-color: $input-border-color-invalid-hover;
    }

    &:focus {
      border-color: $input-border-color-invalid-focus;
    }
  }

  &:hover {
    border-color: $input-border-color-hover;
  }

  &:focus,
  &:active {
    border-color: $input-border-color-focus;
    outline: none;
  }

  &.disabled {
    border-color: $input-border-color-disabled;
    color: $input-font-color-disabled;
    cursor: not-allowed;

    &:hover,
    &:focus,
    &:active {
      border-color: $input-border-color-disabled;
    }
  }
}

// Appearance

.outline {
  background: $input-outline-bg;
  border-width: $input-border-width;
  border-radius: $input-border-radius;
  padding-left: $space-s;
  padding-right: $space-s;

  &.editable {
    @include shadow("inset");
  }
}

.underline {
  border-bottom-width: $input-border-width;
}

.silent {
  &:hover,
  &:focus,
  &:active {
    border-bottom-width: $input-border-width;
  }
  &.disabled {
    &:hover,
    &:focus,
    &:active {
      border-bottom-width: 0;
    }
  }
}

// Size

.s {
  height: $input-height-s;
}
.m {
  height: $input-height-m;
}
.l {
  font-size: $input-font-size-l;
  height: $input-height-l;
}

// Alignment

.center {
  text-align: center;
}

.right {
  text-align: right;
}
